import { render, staticRenderFns } from "./credit-explanation.vue?vue&type=template&id=d4583a9a&scoped=true&"
import script from "./credit-explanation.vue?vue&type=script&lang=js&"
export * from "./credit-explanation.vue?vue&type=script&lang=js&"
import style0 from "./credit-explanation.vue?vue&type=style&index=0&id=d4583a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4583a9a",
  null
  
)

export default component.exports